const langPopoverButton = document.querySelector(".js-lang-popover-button");
const langPopover = document.querySelector(".js-lang-popover");

if (langPopoverButton) {
  langPopoverButton.addEventListener("click", () => {
    if (langPopover) {
      langPopover.classList.toggle("show");
    }
  });
}

// When click outside
document.querySelector(".wrap").addEventListener("click", (event) => {
  const isClickedinButton = event.target.classList.contains("js-lang-popover-button");
  if (!isClickedinButton) {
    langPopover.classList.remove("show");
  }
});
